// extracted by mini-css-extract-plugin
module.exports = {"layout":"style_layout__5MxZg","layout-body":"style_layout-body__yILNK"};